import { State } from '../core.state';

export const selectUser = (state: State) => state.users.user;

export const selectIsLoggedIn = (state: State) => state.users.loggedIn;

export const selectIsImpersonating = (state: State) => state.users.isImpersonating;

export const selectImpersonationPending = (state: State) => state.users.impersonationPending;

export const selectImpersonationRequested = (state: State) => state.users.impersonationRequested;

export const selectImpersonationTargetUserId = (state: State) =>
  state.users.impersonationTargetUserId;

export const selectImpersonationError = (state: State) => state.users.impersonationError;

export const selectTutorsList = (state: State) => state.users.tutorsList;
export const selectTutorsLoading = (state: State) => state.users.tutorsLoading;
export const selectSelectedTutorProfile = (state: State) => state.users.selectedTutorProfile;
export const selectTutorProfileLoading = (state: State) => state.users.tutorProfileLoading;
export const selectTutorProfileError = (state: State) => state.users.tutorProfileError;
